import { motion } from 'motion/react'
import React from 'react'

import { useFocusTransition } from 'slab'

interface ConfirmationProps {
  message: React.ReactNode;
  subText: React.ReactNode;
}

export function Confirmation ({ message, subText }: ConfirmationProps) {
  useFocusTransition()

  return (
    <motion.div
      className='flex flex-col gap-1 text-center py-3'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <p className='body-bold'>{message}</p>
      <p className='body'>{subText}</p>
    </motion.div>
  )
}

Confirmation.displayName = 'InProductFeedback.Confirmation'
